import ImageGallery from "react-image-gallery";
import './style.css'
import { Typography } from "@mui/material";
import { useTheme } from "@emotion/react";

function PhotoGallery({data}) {
    const {fontSize} = useTheme();
  return (
    <div className="app">
     
      <div className="image-gallery-wrapper">
        <ImageGallery items={data}/>
      </div>
    </div>
  );
}

export default PhotoGallery;